<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading">
    <div class="contents-wrapper">
      <div class="contents-container">
        <div class="image-wrapper">
          <app-zaver-icon class="icon-user-img" [size]="80" name="bankSignalCircle"></app-zaver-icon>
        </div>
        <div class="heading">Identifiering och verifiering</div>
        <div class="sub-heading">
          I nästa steg får du autentisera dig med BankID och sedan koppla upp
          dig mot din bank. Vänligen välj din huvudsakliga bank.
        </div>

        <div class="button-container">
          <zaver-primary-button
            text="Nästa"
            [disabled]="navigationInProgress || loading"
            (click)="handleCtaClick()"
          ></zaver-primary-button>

          <div class="terms-text">
            Genom att fortsätta godkänner du Zavers

            <a
              class="disclaimer-link"
              target="_blank"
              href="https://link.zaver.com/terms/se/privacy"
            >
              Integritetspolicy
            </a>
            och
            <a
              class="disclaimer-link"
              target="_blank"
              href="https://link.zaver.com/terms/se/cookies"
            >
              Cookiepolicy
            </a>
            samt att en kreditupplysning inhämtas.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
